import AppointmentPreview from './AppointmentPreview';

import './index.css';

export default AppointmentPreview;
